// 配置编译环境和线上环境之间的切换
const env = process.env
const baseUrl = env.VUE_APP_BASE_URL

// 图表库为avue和pig2套地址
const iconfontVersion = ['667895_v7uduh4zui', '1638883_qi08jij1ln', '2917455_gn0om6v9ytc']
const iconfontUrl = '//at.alicdn.com/t/font_$key.css'

const actUrl = `${window.location.origin}/act/modeler.html?modelId=`
const oauthUrl = env.VUE_APP_OAUTH_URL

//设置环境
const getImgUrl = (imgUrl) => {
	if (!imgUrl || imgUrl === '') {
		return ''
	}
	let prefixUrl = env.VUE_APP_IMG_URL
	return imgUrl.indexOf('http') !== -1 ? imgUrl : prefixUrl + imgUrl
}

//区分环境
//ie
const ieTest = 'https://fx.test.boweibx.com'
const iePro = 'https://pro.boweibx.com'
const ieProHttp = 'http://pro.boweibx.com'
const ieJtTest = 'https://iebx.m8bj.cn'
const ieJtPro = 'https://bx.iebx.cn'

//新市民
const xsmTest = 'https://xsmbw.m8bj.cn'
const xsmTestOld = 'http://fx.m8bj.cn:18887'
const xsmPro = 'https://www.xinshiminbao.com'
const xsmProOld = 'https://xinshiminbao.com'
const xsmTestMb = 'https://xsmbx.m8bj.cn'
const xsmProMb = 'https://bx.xinshiminbao.cn'

//美的光伏租户 ID：21
//测试环境域名：partner.m8bj.cn
//正式环境域名：partner.iebx.cn
const meiGuangFuTest = 'https://partner.m8bj.cn'
const meiGuangFuPro = 'https://partner.iebx.cn'

const origin = window.location.origin || ''

function isLocalHost() {
	return origin.includes('localhost')
}

function getProductType(pType) {
	return (pType === baseUrl && origin.includes('localhost')) || pType === origin
}

//ie保(博维和吉泰)
function isBxIe() {
	return isBxIeBw() || isBxIeJT()
}

//ie保(博维)
function isBxIeBw() {
	return isBxIeBwTest() || isBxIeBwPro()
}

//ie保(吉泰)
function isBxIeJT() {
	return isBxIeJtTest() || isBxIeJtPro()
}

//ie保(博维)
function isBxIeBwTest() {
	return getProductType(ieTest)
}

//ie保(博维)
function isBxIeBwPro() {
	return getProductType(iePro) || getProductType(ieProHttp)
}

//ie保吉泰测试
function isBxIeJtTest() {
	return getProductType(ieJtTest)
}

//ie保吉泰正式
function isBxIeJtPro() {
	return getProductType(ieJtPro)
}

//新市民
function isBxXsm() {
	return isBxXsmTest() || isBxXsmPro()
}

//新市民测试
function isBxXsmTest() {
	return getProductType(xsmTest) || getProductType(xsmTestMb)
}

//新市民正式
function isBxXsmPro() {
	return getProductType(xsmPro) || getProductType(xsmProMb)
}

//判断吉泰返回的消息
function isBxJtMsg(origin) {
	return origin === ieJtTest || origin === ieJtPro || origin === ieTest || origin === iePro
}

//美的光伏
function isBxMeidiGuangfu() {
	return isBxMeidiGuangfuTest() || isBxMeidiGuangfuPro()
}

//美的光伏测试
function isBxMeidiGuangfuTest() {
	return getProductType(meiGuangFuTest)
}

//美的光伏正式
function isBxMeidiGuangfuPro() {
	return getProductType(meiGuangFuPro)
}

//获取基础路径
function getBaseUrl() {
	return origin.includes('localhost') ? baseUrl : origin
}

function isBxTest() {
	let baseUrl = getBaseUrl()
	return baseUrl.includes('test') || baseUrl.includes('localhost') || baseUrl.includes('m8bj')
}

function getBxRelaunchUrl() {
	return isBxTest() ? ieJtTest : ieJtPro
}

function isHttps() {
	return origin.includes('https')
}

/**
 * 根据不同域名获取配置文件
 */
function getDiffEnvConfig() {
	let tempBaseUrl = getBaseUrl()
	let isTest = tempBaseUrl.includes('test') || tempBaseUrl.includes('m8bj')
	let baseConfig = {
		NODE_ENV: isTest ? 'development' : 'production',
		VUE_APP_BASE_URL: tempBaseUrl,
		//回溯
		VUE_APP_RRLOG_ID: isTest ? 'insuranceagent_test' : 'insuranceagent',
		VUE_APP_RRLOG_URL: isTest ? 'https://rrlog.test.meibaokeji.com' : 'https://rrlog.meibaokeji.com',
		// #跳转登录
		VUE_APP_OAUTH_URL: isTest
			? 'https://admin-auth-test.meibaokeji.com/oauth/authorize?scope=all&response_type=code&redirect_uri=http%3A%2F%2Fiebx.m8bj.cn%2F%23%2Flogin&client_id=insuranceagent&state=unity'
			: 'https://admin-auth.meibaokeji.com/oauth/authorize?scope=all&response_type=code&redirect_uri=https%3A%2F%2Fbx.iebx.cn%2F%23%2Flogin&client_id=insuranceagent&state=unity',

		VUE_APP_IMG_URL: isTest ? 'https://mbtest.meibaokeji.com' : 'https://boweibx.com',
		VUE_APP_SENSORS_URL: `${tempBaseUrl}/admin/event`,

		planUrl: isTest ? 'http://fx.m8bj.cn:28887/middle/#/planMake' : 'https://safety.meibaokeji.com/middle/#/planMake',
	}
	//不同配置
	let VUE_APP_CHANNELID = ''
	let VUE_APP_APPID = ''
	if (isBxIeBw()) {
		VUE_APP_CHANNELID = 1
		VUE_APP_APPID = 'sTaG5B9uB5NAvDo9'
	} else if (isBxXsm()) {
		VUE_APP_CHANNELID = 3
		VUE_APP_APPID = 'uvw1QBFEwrmJtjYF'
	} else if (isBxIeJtTest()) {
		VUE_APP_CHANNELID = 1
		VUE_APP_APPID = 'wQLhCncy6ktTHGse'
	} else if (isBxIeJtPro()) {
		VUE_APP_CHANNELID = 1
		VUE_APP_APPID = 'kA7Q3Jf3qr07jLuK'
	} else if (isBxMeidiGuangfu()) {
		VUE_APP_CHANNELID = 21
		VUE_APP_APPID = '5mNL3HEuyPJbF6qm'
	}
	return Object.assign(baseConfig, {VUE_APP_CHANNELID, VUE_APP_APPID})
}

export {
	ieJtTest,
	ieJtPro,
	xsmTest,
	xsmPro,
	xsmTestMb,
	xsmProMb,
	meiGuangFuTest,
	meiGuangFuPro,
	baseUrl,
	actUrl,
	iconfontUrl,
	iconfontVersion,
	oauthUrl,
	env,
	getImgUrl,
	isBxIe,
	isBxIeBwTest,
	isBxIeBwPro,
	isBxXsm,
	isBxXsmTest,
	isBxXsmPro,
	isBxIeBw,
	isBxIeJtTest,
	isBxIeJtPro,
	isBxIeJT,
	isBxJtMsg,
	isBxMeidiGuangfu,
	isBxMeidiGuangfuTest,
	isBxMeidiGuangfuPro,
	getBaseUrl,
	getDiffEnvConfig,
	isBxTest,
	getBxRelaunchUrl,
	isLocalHost,
	isHttps,
}
